module.exports = __webpack_public_path__ + "img/组 14.9e33e8ff.png";